<template>

  <!--左边菜单树-->
    <div class="leftmenu">
      <div class="menu-class" v-for="(item,index) in menuList">
        <a class="a-menu-class" @click="toRouterByUrl(item.url)">{{item.name}}</a>
      </div>
    </div>
</template>

<script>
export default {
  name: "LeftMenu.vue"
  ,
  components: {},
  data() {
    return {
      menuList:[

      ]}
  },
  methods: {
    toRouterByUrl(url){
      this.$router.push(url);
    },
    initForm(){
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
      if(this.userInfo.BUSINESSID=="" || this.userInfo.BUSINESSID ==null){
        this.menuList=[
          {
            "name":"单据下发",
            "url":"/members"
          },
          {
            "name":"采购入库查询",
            "url":"/purInQuery"
          },
          {
            "name":"采购明细查询",
            "url":"/purFlowQuery"
          },
          {
            "name":"销售开票查询",
            "url":"/saleOutQuery"
          },
          {
            "name":"销售出库查询",
            "url":"/saleOut"
          },
          {
            "name":"销售明细查询",
            "url":"/saleFlowQuery"
          },
          {
            "name":"仓库冲红查询",
            "url":"/wmsBluntQuery"
          },
          {
            "name":"我的库存查询",
            "url":"/myBalanceQuery"
          },
          {
            "name":"平台库存查询",
            "url":"/platformBalanceQuery"
          },
        ]
      }else{
        this.menuList=[

          {
            "name":"销售开票查询",
            "url":"/clientSaleNotesQuery"
          },
          // {
          //   "name":"销售出库查询",
          //   "url":"/saleOut"
          // },
          {
            "name":"销售明细查询",
            "url":"/clientSaleFlowQuery"
          },
        ]
      }
    }
  },
  mounted() {
      this.initForm();
  }
}
</script>

<style scoped>
.leftmenu{
  background: #f1f1f1;
  width: 130px;
  margin-left: 10%;
  height:100%;
}
.menu-class{
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #e9e8e9;
  font-size: 15px;
}
.a-menu-class{
  cursor:pointer;
}
.a-menu-class:hover{
  text-decoration: underline;
}
.a-menu-class:visited{
  background-color:yellow;
}
</style>



// WEBPACK FOOTER //
// src/components/component/LeftMenu.vue